const indexItems = [
  { label: '科幻大片', icon: 'ri-rocket-2-line', count: '1,286部', color: 'primary' },
  { label: '古装剧集', icon: 'ri-building-2-line', count: '2,450部', color: 'accent' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '1,830部', color: 'primary' },
  { label: '热血动漫', icon: 'ri-flashlight-line', count: '3,120部', color: 'accent' },
  { label: '喜剧合集', icon: 'ri-emotion-laugh-line', count: '2,680部', color: 'primary' },
  { label: '动作猛片', icon: 'ri-sword-line', count: '3,540部', color: 'accent' },
  { label: '韩剧专区', icon: 'ri-heart-line', count: '1,960部', color: 'primary' },
  { label: '综艺节目', icon: 'ri-tv-2-line', count: '920部', color: 'accent' },
];

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按题材精心整理的观影分类，快速找到你的心头好
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-background-300/60 transition-all duration-300 group cursor-pointer"
            >
              <div
                className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center mb-3 ${
                  item.color === 'primary'
                    ? 'bg-primary-500/12 text-primary-500'
                    : 'bg-accent-500/12 text-accent-400'
                }`}
              >
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1">{item.label}</h3>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}